import { ReactComponent as LogoBig } from '../../assets/LogoBig.svg'
import styles from './signup.module.css'
import { ReactComponent as GoogleIcon } from '../../assets/Google.svg'
import { ReactComponent as MicrosoftIcon } from '../../assets/Microsoft.svg'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { getApiUrl } from '../../config/env'

const Signup = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const handleSignUp = async () => {
        setIsLoading(true)
        setError('')

        try {
            const response = await fetch(getApiUrl('/auth/email/register'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    password,
                }),
            });

            const data = await response.json();


            if (!response.ok) {
                throw new Error(data.message || 'Registration failed');
            }

            console.log(data.access_token)

            localStorage.setItem('token', data.access_token);
            navigate('/builder');
        } catch (error) {
            setError(error instanceof Error ? error.message : 'An error occurred');
            window.alert(error)
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <LogoBig />
            <div className={styles.loginBox}>
                <p className={styles.title}>Get started with Convexity</p>
                <div className={styles.divider} />
                <div className={styles.formContainer}>
                    <input
                        className={styles.input}
                        placeholder='Your work email'
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={isLoading}
                    />
                    <input
                        className={styles.input}
                        placeholder='Password'
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={isLoading}
                    />
                    <button
                        className={styles.signInButton}
                        onClick={handleSignUp}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Signing up...' : 'Sign up'}
                    </button>
                    <div className={styles.orDividerContainer}>
                        <div className={styles.dividerLine} />
                        <p className={styles.orText}>OR</p>
                        <div className={styles.dividerLine} />
                    </div>
                    <button className={styles.socialButton}>
                        <GoogleIcon />
                        Continue with Google
                    </button>
                    <button className={styles.socialButton}>
                        <MicrosoftIcon />
                        Continue with Microsoft
                    </button>
                </div>
            </div>
            <p className={styles.signInText}>Already have an account? <a className={styles.signInLink} onClick={() => navigate('/login')}>Sign in</a></p>
            <div className={styles.footer}>
                <p className={styles.footerLink}>Privacy Policy</p>
                <p className={styles.footerLink}>Terms of Service</p>
            </div>
        </div>
    )
}

export default Signup
